import "./App.css";
import { Switch, Route } from "react-router-dom";
import Home from "./pages/home";
import { Container } from "semantic-ui-react";

function App() {
  return (
    <Container>
      <Switch>
        <Route exact path="/" component={Home} />
      </Switch>
    </Container>
  );
}

export default App;
